import styled from 'styled-components'
import { dotsAnimation } from '@/constants/styles/animations'

export const TextPlaceholder = styled.span`
    &::after {
        content: ' .';
        animation: ${dotsAnimation} 1s steps(5, end) infinite;
    }
`
